import React from 'react';

import { findActiveOption } from '../util';

import type { PostContainsFilter } from 'common/automations/constants';
import Input from 'common/uiV3/Input';
import { Select } from 'common/uiV3/Select';

interface Props {
  condition: PostContainsFilter['condition'];
  value: PostContainsFilter['value'];
  onChange: (
    condition?: PostContainsFilter['condition'],
    value?: PostContainsFilter['value'],
  ) => void;
  required: boolean;
}

const PostContent = ({ required, ...props }: Props) => {
  const { condition, value, onChange } = props;

  const conditionOptions = [
    {
      label: 'Contains all of',
      value: 'containsAll',
    },
    {
      label: 'Contains any of',
      value: 'containsAny',
    },
  ];
  const activeOption = findActiveOption(conditionOptions, condition);

  return (
    <>
      <div className="filterField1of2">
        <Select
          onValueChange={(option) =>
            option && onChange(option as PostContainsFilter['condition'], value)
          }
          options={conditionOptions}
          placeholder="Contains"
          value={activeOption?.value}
          fullWidth
        />
      </div>
      <div className={required ? 'filterField2of2-required' : 'filterField2of2'}>
        <Input
          onChange={(value) => onChange(condition, value.split(','))}
          placeholder="Keywords"
          value={value.join(',')}
        />
      </div>
    </>
  );
};
export default PostContent;
